<template>
  <div>
    <div class="is-percent">
      <button @click="isPercent = false" :class="{ active: !isPercent }">
        {{ parseTranslation(NUMBER) }}
      </button>

      <button @click="isPercent = true" :class="{ active: isPercent }">
        {{ parseTranslation(PERCENTAGE) }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationConfigItems from './configItem.translations'

const { default: translations, ...translationKeys } = translationConfigItems

export default {
  name: 'ConfigPercent',

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    groupCode: {
      required: true,
    },
  },

  data() {
    return {
      isPercent: false,

      translations,
      ...translationKeys,
    }
  },

  watch: {
    isPercent() {
      this.setPercent()
    },
  },

  methods: {
    ...mapActions(['setChartSettings']),

    setPercent() {
      this.setChartSettings({
        setting: {
          ...this.question_result?.chartSettings,

          isPercent: this.isPercent,
        },

        groupCode: this.groupCode,
        questionCode: this.question_result.code,
      })
    },
  },

  mounted() {
    this.isPercent = this.question_result?.chartSettings?.isPercent || false
  },
}
</script>

<style lang="scss" scoped>
.title {
  @include chart-config-title;
}

.is-percent {
  text-align: center;
  button {
    @include primary-general-button;
    background: $white;
    color: $main;
    margin: 20px 0;
    width: 140px;

    &:nth-of-type(1) {
      margin-right: 20px;
    }

    &.active {
      color: $white;
      background: $blue;
    }
  }

  @media (max-width: 400px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 30px;

    button {
      max-width: 145px;
      width: 100%;

      &:nth-of-type(1) {
        margin: 0 0 20px 0;
      }
    }
  }
}
</style>
